import { loadableWithFallback } from '@vision/ui/utils';
import type { ScatterChart1Props } from './ScatterChart1';

export const ScatterChart1 = loadableWithFallback<ScatterChart1Props>(() => import('./ScatterChart1'));
